import { type FeatureFlagsContextType } from "./types";

const isTidEnabled = import.meta.env.VITE_FEATURE_TID_ENABLED === "true";
const isManageUserAccessEnabled =
  import.meta.env.VITE_FEATURE_MANAGE_USER_ACCESS_ENABLED === "true";

export const defaultFeatureFlagsContext: FeatureFlagsContextType = {
  isTidEnabled,
  isManageUserAccessEnabled,
};
